import { doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import type { BattlebotResponse, BattlebotsReview } from './types';

export const getBattlebots = (candidateQuantity: number = 2) => {
  return doGet<BattlebotResponse>(
    `battlebots/candidates?num_candidates=${candidateQuantity}`,
    LOGGER_TYPE.BATTLEBOTS,
  );
};

export const postBattlebots = (review: BattlebotsReview) => {
  return doPost('battlebots/reviews', LOGGER_TYPE.BATTLEBOTS, review);
};
